"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSkillUsageAnalyticsDTO = exports.GetBattleTimeoutAnalyticsDTO = exports.GetBattlesAnalyticsDTO = exports.MapBattleAnalyticsDTO = exports.GoalBattleAnalyticsDTO = exports.BattleContextBattleAnalyticsDTO = exports.PlacesBattlesAnalyticsDTO = exports.BattleTimeoutAnalyticsDTO = exports.SkillUsageAnalyticsDTO = void 0;
const class_validator_1 = require("class-validator");
class SkillUsageAnalyticsDTO {
}
exports.SkillUsageAnalyticsDTO = SkillUsageAnalyticsDTO;
class BattleTimeoutAnalyticsDTO {
}
exports.BattleTimeoutAnalyticsDTO = BattleTimeoutAnalyticsDTO;
class PlacesBattlesAnalyticsDTO {
}
exports.PlacesBattlesAnalyticsDTO = PlacesBattlesAnalyticsDTO;
class BattleContextBattleAnalyticsDTO {
}
exports.BattleContextBattleAnalyticsDTO = BattleContextBattleAnalyticsDTO;
class GoalBattleAnalyticsDTO {
}
exports.GoalBattleAnalyticsDTO = GoalBattleAnalyticsDTO;
class MapBattleAnalyticsDTO {
}
exports.MapBattleAnalyticsDTO = MapBattleAnalyticsDTO;
let GetBattlesAnalyticsDTO = (() => {
    class GetBattlesAnalyticsDTO {
    }
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], GetBattlesAnalyticsDTO.prototype, "from", void 0);
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], GetBattlesAnalyticsDTO.prototype, "to", void 0);
    return GetBattlesAnalyticsDTO;
})();
exports.GetBattlesAnalyticsDTO = GetBattlesAnalyticsDTO;
let GetBattleTimeoutAnalyticsDTO = (() => {
    class GetBattleTimeoutAnalyticsDTO {
    }
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], GetBattleTimeoutAnalyticsDTO.prototype, "from", void 0);
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], GetBattleTimeoutAnalyticsDTO.prototype, "to", void 0);
    return GetBattleTimeoutAnalyticsDTO;
})();
exports.GetBattleTimeoutAnalyticsDTO = GetBattleTimeoutAnalyticsDTO;
let GetSkillUsageAnalyticsDTO = (() => {
    class GetSkillUsageAnalyticsDTO {
    }
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], GetSkillUsageAnalyticsDTO.prototype, "from", void 0);
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], GetSkillUsageAnalyticsDTO.prototype, "to", void 0);
    return GetSkillUsageAnalyticsDTO;
})();
exports.GetSkillUsageAnalyticsDTO = GetSkillUsageAnalyticsDTO;
//# sourceMappingURL=Analytics.js.map